const $ = require("jquery");
var log = console.log;

define(function (require) {
    require("@modules/tools/ko.async");
    require("@modules/tools/ko.extensions");
    require("@modules/tools/ko.bindingHandlers");

    var ko = require("knockout");
    var $ = require("jquery");
    // var moment = require("moment");
    var util = require("@modules/utils");
    var PhysicianResultViewModel = require("@modules/tools/provider-search/physicianResultViewModel");
    var urlParameters = require("@modules/tools/urlParameters");
    var geocoder = require("@modules/tools/geocoder");
    var querystring = require("querystring");
    var loadedQuerystring = querystring.parse();
    var getPropertyCaseInsensitive = require("@modules/insensitiveProperty");
    var utility = require("@modules/tools/helpfulToolUtility");
    var whitelistUrlService = require("@modules/tools/whitelistUrlService");
    var $toggleDefinitions = $(".toggle-definitions");

    // ProviderSearchViewModel ctor
    return function (gtmDataLayerPush, gmapApi) {
        var self = this;
        var focusedElement;
        var defaultParameters = {
            zipOrAddress: "",
            radius: "5",
            pageNumber: 1,
            year: window.scan.aepYears[window.scan.aepYears.length - 1],
            sort: "distance",
            selectPcp: false,
            groupId: "",
            lgbtqPlus: false,
            deepLink: false,
            culturetraining: false,
            phoneNumber: "",
            productType: []
        };

        var dataLayer = window.dataLayer || [];
        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        dataLayer.push({
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Doctors Search"
        });

        var initialLoad = true;
        var nonPrimaryFiltersApplied;
        var pageSize = window.scan.resultPageSize > 0 ? window.scan.resultPageSize : 20;
        var tempResults = [];

        // api service
        self.providerService = require("@modules/tools/provider-search/providerService");

        // track the parameters used for the currently displayed search results
        self.currentSearchParameters = ko.observable();

        // various flags/state properties
        // self.initialLoad = ko.pureComputed(function() { return initialLoad; });
        // self.isSettingParameters = ko.observable(false);
        self.isSearchStarted = ko.observable(false);
        self.pageSize = ko.observable(pageSize);
        self.pageNumber = ko.observable(1);
        self.fatalError = ko.observable(false);
        self.detailId = ko.observable();
        self.isLeavingForDetailPage = ko.observable(false);
        self.loadDefaultLanguageFilter = ko.observable(false);
        self.loadDefaultHospitalFilter = ko.observable(false);
        self.loadDefaultlgbtqplus = ko.observable(true);
        self.loadDefaultculturetraining = ko.observable(true);
        self.loadDefaultTitle = ko.observable(true);
        self.loadDefaultPanelStatusCode = ko.observable(true);
        self.loadDefaultinofficevisits = ko.observable(true);
        self.loadDefaultMobileavailable = ko.observable(true);
        self.loadDefaultMobileonly = ko.observable(true);
        self.loadDefaultTelehealthonly = ko.observable(true);
        self.loadDefaultTelehealthavailable = ko.observable(true);
        self.loadDefaultRadius = ko.observable(true);
        self.showEffectiveDate = ko.observable(true);
        self.loadDefaultphoneNumber = ko.observable(true);
        var isSystemResettingFilters = false;

        var urlParams = urlParameters.read();

        //Deep link
        self.deepLink = ko.observable({ defaultOnNull: defaultParameters.deepLink });

        var returnUrl = getPropertyCaseInsensitive(urlParams, "return_url");
        var findMyPcp = getPropertyCaseInsensitive(urlParams, "findmypcp");
        var includeAddressSuffix = getPropertyCaseInsensitive(urlParams, "include_address_suffix");
        var agaId = getPropertyCaseInsensitive(urlParams, "id");
        var nonEncodedPath = getPropertyCaseInsensitive(urlParams, "path");
        var path = nonEncodedPath ? encodeURIComponent(nonEncodedPath) : nonEncodedPath;

        if (urlParams.year) {
            urlParams.year = parseInt(urlParams.year, 10); // make the year a number if set in url
        }
        if (urlParams.pageNumber) {
            urlParams.pageNumber = parseInt(urlParams.pageNumber, 10); // make the pageNumber a number if set in url
        }

        if (urlParams.selectPcp && (urlParams.selectPcp === "true" || urlParams.selectPcp === "false")) {
            urlParams.selectPcp = JSON.parse(urlParams.selectPcp);
        } else {
            urlParams.selectPcp = false;
        }

        if (urlParams.deepLink && (urlParams.deepLink === "true" || urlParams.deepLink === "false")) {
            urlParams.deepLink = JSON.parse(urlParams.deepLink);
        } else {
            urlParams.deepLink = false;
        }

        if (urlParams.goewPbp && (urlParams.goewPbp === "true" || urlParams.goewPbp === "false")) {
            urlParams.goewPbp = JSON.parse(urlParams.goewPbp);
        } else {
            urlParams.goewPbp = false;
        }

        // ARRAY-ify urlParams
        if (urlParams.productType && !$.isArray(urlParams.productType)) {
            urlParams.productType = [urlParams.productType];
        }
        if (urlParams.languages && !$.isArray(urlParams.languages)) {
            urlParams.languages = [urlParams.languages];
            if (urlParams.deepLink == true) {
                self.loadDefaultLanguageFilter(true);
            }
        }
        if (urlParams.groups && !$.isArray(urlParams.groups)) {
            urlParams.groups = [urlParams.groups];
        }
        if (urlParams.specialties && !$.isArray(urlParams.specialties)) {
            urlParams.specialties = [urlParams.specialties];
        }
        if (urlParams.hospitals && !$.isArray(urlParams.hospitals)) {
            urlParams.hospitals = [urlParams.hospitals];
            if (urlParams.deepLink == true) {
                self.loadDefaultHospitalFilter(true);
            }
        }

        if (urlParams.deepLink == true && urlParams.lgbtqplus && (urlParams.lgbtqplus === "true" || urlParams.lgbtqplus === "false")) {
            self.loadDefaultlgbtqplus(false);
        }

        if (urlParams.deepLink == true && urlParams.culturetraining && (urlParams.culturetraining === "true" || urlParams.culturetraining === "false")) {
            self.loadDefaultculturetraining(false);
        }

        if (urlParams.phoneNumber && urlParams.deepLink == true) {
            self.loadDefaultphoneNumber(false);
        }

        if (urlParams.title) {
            self.loadDefaultTitle(false);
        }

        if (urlParams.panelStatusCode && urlParams.deepLink == true) {
            self.loadDefaultPanelStatusCode(false);
        }

        if (urlParams.inofficevisits) {
            self.loadDefaultinofficevisits(false);
        }

        if (urlParams.mobileavailable) {
            self.loadDefaultMobileavailable(false);
        }

        if (urlParams.mobileonly) {
            self.loadDefaultMobileonly(false);
        }

        if (urlParams.telehealthonly) {
            self.loadDefaultTelehealthonly(false);
        }

        if (urlParams.telehealthavailable) {
            self.loadDefaultTelehealthavailable(false);
        }

        if (urlParams.radius && urlParams.deepLink == true) {
            self.loadDefaultRadius(false);
        }

        if (!urlParams.effectiveDate) {
            self.showEffectiveDate(false);
        }

        if (window.scan && window.scan.returnUrlYearMap && window.scan.returnUrlYearMap && returnUrl) {
            var year = getPropertyCaseInsensitive(window.scan.returnUrlYearMap, returnUrl);
            if (year) {
                defaultParameters.year = year;
            }
        }

        self.isDrx = ko.observable(false);

        if (returnUrl) {
            whitelistUrlService
                .validateUrl(returnUrl)
                .done(function (data) {
                    self.isDrx(true);
                })
                .fail(function (jqXHR) {
                    console.log(jqXHR.responseJSON.Message);
                });
        }

        // form field values
        self.sort = ko.observable().extend({ defaultOnNull: defaultParameters.sort });
        self.zipOrAddress = ko.observable();
        self.state = ko.observable(window.scan.stateValueDefault || "CA");
        self.radius = ko.observable();
        self.goewPbp = ko.observable();
        self.pcpToOe = ko.observable(findMyPcp === "true");
        self.name = ko.observable("");
        self.year = ko.observable().extend({ defaultOnNull: defaultParameters.year });
        self.pcponly = ko.observable(false);
        self.inofficevisits = ko.observable(false);
        self.mobileavailable = ko.observable(false);
        self.mobileonly = ko.observable(false);
        self.telehealthavailable = ko.observable(false);
        self.telehealthonly = ko.observable(false);
        self.lgbtqplus = ko.observable(false);
        self.culturetraining = ko.observable(false);
        self.specialties = ko.observableArray([]);
        var panelStatusCode = self.isDrx() ? "ACCEPTS" : "";
        self.panelStatusCode = ko.observable(panelStatusCode);
        self.groups = ko.observableArray([]);
        self.plans = ko.observableArray([]);
        self.staticPlans = ko.observableArray([]);
        self.gender = ko.observable("");
        self.languages = ko.observableArray([]);
        self.title = ko.observable("");
        self.hospitals = ko.observableArray([]);
        self.tempPhoneNumber = ko.observable("");
        self.phoneNumberErrorMessage = ko.observable("");
        self.phoneNumber = ko.observable("");
        // to support changing PCP
        self.selectPcp = ko.observable({ defaultOnNull: defaultParameters.selectPcp });
        self.effectiveDate = ko.observable();
        self.effectiveDateDisplay = ko.computed(function () {
            // return moment(self.effectiveDate()).format("MM/DD/YYYY");
            // @TODO: test this new date format matches "MM/DD/YYYY"
            return new Date(self.effectiveDate()).toLocaleDateString("en-US");
        });
        self.currentPcpId = ko.observable(window.scan.currentPcpId || "");
        self.groupId = ko.observable();
        self.productType = ko.observable(urlParams.productType || "");
        if (urlParams.productType) {
            self.plans(urlParams.productType);
            self.staticPlans([{ "value": urlParams.productType[0], "text": window.scan.productTypeName }]);
        }

        // end support changing PCP

        if (urlParams.phoneNumber) {
            self.tempPhoneNumber(urlParams.phoneNumber);
        }

        self.isViewAllFilterCollapsed = ko.observable(false);

        self.allFilterCallapsed = function (ele) {
            self.isViewAllFilterCollapsed(ele);
        };

        if (urlParams.scan_state) {
            self.state(urlParams.scan_state);
            urlParams.state = urlParams.scan_state;
        }

        self.tempPhoneNumber.subscribe(function () {
            var regex = new RegExp("^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[s.-]?\\d{3}[\\s.-]?\\d{4}$");
            if (regex.test(self.tempPhoneNumber())) {
                self.phoneNumber(self.tempPhoneNumber());
            } else {
                if (self.tempPhoneNumber() == "") {
                    self.phoneNumber("");
                }
            }
        });

        var primaryFilters = {
            sort: self.sort,
            state: self.state,
            zipOrAddress: self.zipOrAddress,
            radius: self.radius,
            name: self.name,
            year: self.year,
            pcponly: self.pcponly,
            inofficevisits: self.inofficevisits,
            mobileavailable: self.mobileavailable,
            mobileonly: self.mobileonly,
            telehealthavailable: self.telehealthavailable,
            telehealthonly: self.telehealthonly,
            lgbtqplus: self.lgbtqplus,
            culturetraining: self.culturetraining,
            specialties: self.specialties,
            panelStatusCode: self.panelStatusCode,
            selectPcp: self.selectPcp,
            deepLink: self.deepLink,
            phoneNumber: self.phoneNumber
        };

        var secondaryFilters = {
            groups: self.groups,
            productType: self.plans,
            gender: self.gender,
            languages: self.languages,
            title: self.title,
            hospitals: self.hospitals
        };

        // for typeahead
        self.suggestions = ko.observableArray([]);
        //we need this to populate the updated date in the footer for the PDF
        self.contextItemId = ko.observable(window.scan.contextItemId);

        // ************************************************************************
        // OBSERVABLE ARRAYS ******************************************************
        // dropdown/checkbox options
        self.yearOptions = ko.observableArray(window.scan.aepYears);
        self.radiusOptions = ko.observableArray(utility.mapFacets(window.scan.emptyRadiusOptions));
        self.stateOptions = ko.observableArray(utility.mapFacets(window.scan.stateOptions));
        self.genderOptions = ko.observableArray([]);
        self.genderOptionsSelected = ko.computed(function () {
            if (self.deepLink() && self.gender() && urlParams.gender) {
                return self.genderOptions().filter(function (gender) {
                    if (!self.gender() || gender.name.toLowerCase() == self.gender().toLowerCase()) return gender;
                });
            } else {
                return [];
            }
        });
        self.specialtyOptions = ko.observableArray([]);
        self.panelStatusCodeOptions = ko.observableArray([]);
        self.panelStatusCodeOptionsSelected = ko.computed(function () {
            return self.panelStatusCodeOptions().filter(function (panelStatusCode) {
                if (!self.panelStatusCode() || panelStatusCode.name.toLowerCase().indexOf(self.panelStatusCode().toLowerCase()) !== -1) return panelStatusCode;
            });
        });
        self.groupOptions = ko.observableArray([]);
        self.languageOptions = ko.observableArray([]);
        self.productOptions = ko.observableArray([]);
        self.titleOptions = ko.observableArray([]);
        self.titleOptionsSelected = ko.computed(function () {
            if (self.deepLink() && self.title() && urlParams.title) {
                return self.titleOptions().filter(function (title) {
                    if (!self.title() || title.name.toLowerCase() == self.title().toLowerCase()) return title;
                });
            } else {
                return [];
            }
        });
        self.hospitalOptions = ko.observableArray([]);

        self.goewPbp = ko.observable(false);

        self.shouldShowExtraFiltersToggle = ko.computed(function () {
            return self.groupOptions().length || self.productOptions().length || self.genderOptions().length || self.languageOptions().length || self.titleOptions().length || self.hospitalOptions().length;
        });

        self.loadingResults = ko.observable(false);
        self.displayRequiredFieldError = ko.observable(false);
        self.hasSearchRun = ko.observable(false);
        self.totalResults = ko.observable(0);
        self.dataLastUpdated = ko.observable("");
        self.results = ko.observableArray();
        self.pageList = ko.observableArray([]);

        // ************************************************************************
        // Overlay ****************************************************************
        // Plan Popup text filter
        self.planNameFilter = ko.observable("");
        self.plansTempNew = ko.observableArray([]);
        self.plansTempOptions = ko.observableArray([]);
        self.plans.subscribe(function () {
            self.plansTempNew(JSON.parse(JSON.stringify(self.plans())));
        });
        self.productOptions.subscribe(function () {
            self.plansTempOptions(self.productOptions());
        });

        self.plansTempOptionsFiltered = ko.computed(function () {
            return this.plansTempOptions().filter(function (plan) {
                if (!self.planNameFilter() || plan.name.toLowerCase().indexOf(self.planNameFilter().toLowerCase()) !== -1) return plan;
            });
        }, this);
        self.clearPlans = function () {
            self.plansTempNew([]);
        };
        self.plansTempNewClear = function () {
            self.plansTempNew(JSON.parse(JSON.stringify(self.plans())));
            self.planNameFilter("");
        };
        self.plansMakeTempReal = function (data, event) {
            self.plans(JSON.parse(JSON.stringify(self.plansTempNew())));
            self.planNameFilter("");
        };

        // ************************************************************************
        // Overlay ****************************************************************
        // Specialty Popup text filter
        self.specialtyNameFilter = ko.observable("");
        self.specialtiesTempNew = ko.observableArray([]);
        self.specialtiesTempOptions = ko.observableArray([]);
        self.specialties.subscribe(function () {
            self.specialtiesTempNew(JSON.parse(JSON.stringify(self.specialties())));
        });
        self.specialtyOptions.subscribe(function () {
            self.specialtiesTempOptions(self.specialtyOptions());
        });

        self.specialtiesTempOptionsFiltered = ko.computed(function () {
            return this.specialtiesTempOptions().filter(function (specialty) {
                if (!self.specialtyNameFilter() || specialty.name.toLowerCase().indexOf(self.specialtyNameFilter().toLowerCase()) !== -1) return specialty;
            });
        }, this);
        self.clearSpecialties = function () {
            self.specialtiesTempNew([]);
        };
        self.specialtiesTempNewClear = function () {
            self.specialtiesTempNew(JSON.parse(JSON.stringify(self.specialties())));
            self.specialtyNameFilter("");
        };
        self.specialtiesMakeTempReal = function (data, event) {
            self.specialties(JSON.parse(JSON.stringify(self.specialtiesTempNew())));
            self.specialtyNameFilter("");
        };

        // ************************************************************************
        // Overlay ****************************************************************
        // Group Popup text filter
        self.groupNameFilter = ko.observable("");
        self.groupsTempNew = ko.observableArray([]);
        self.groupsTempOptions = ko.observableArray([]);
        self.groups.subscribe(function () {
            self.groupsTempNew(JSON.parse(JSON.stringify(self.groups())));
        });
        self.groupOptions.subscribe(function () {
            self.groupsTempOptions(self.groupOptions());
        });
        self.groupsTempOptionsFiltered = ko.computed(function () {
            return this.groupsTempOptions().filter(function (group) {
                if (!self.groupNameFilter() || group.name.toLowerCase().indexOf(self.groupNameFilter().toLowerCase()) !== -1) return group;
            });
        }, this);
        self.clearGroups = function () {
            self.groupsTempNew([]);
        };
        self.groupsTempNewClear = function () {
            self.groupsTempNew(JSON.parse(JSON.stringify(self.groups())));
            self.groupNameFilter("");
        };
        self.groupsMakeTempReal = function (data, event) {
            self.groups(JSON.parse(JSON.stringify(self.groupsTempNew())));
            self.groupNameFilter("");
        };

        // ************************************************************************
        // Overlay ****************************************************************
        // Language Popup text filter
        self.languageFilter = ko.observable("");
        self.languagesTempNew = ko.observableArray([]);
        self.languagesTempOptions = ko.observableArray([]);
        self.languages.subscribe(function () {
            self.languagesTempNew(JSON.parse(JSON.stringify(self.languages())));
        });
        self.languageOptions.subscribe(function () {
            self.languagesTempOptions(self.languageOptions());
        });
        self.languagesTempOptionsFiltered = ko.computed(function () {
            return this.languagesTempOptions().filter(function (language) {
                if (!self.languageFilter() || language.name.toLowerCase().indexOf(self.languageFilter().toLowerCase()) !== -1) return language;
            });
        }, this);
        self.clearLanguages = function () {
            self.languagesTempNew([]);
        };
        self.languagesTempNewClear = function () {
            self.languagesTempNew(JSON.parse(JSON.stringify(self.languages())));
            self.languageFilter("");
        };
        self.languagesMakeTempReal = function (data, event) {
            self.languages(JSON.parse(JSON.stringify(self.languagesTempNew())));
            self.languageFilter("");
        };
        // ************************************************************************

        // ************************************************************************
        // Overlay ****************************************************************
        // Hospital Popup text filter
        self.hospitalFilter = ko.observable("");
        self.hospitalsTempNew = ko.observableArray([]);
        self.hospitalsTempOptions = ko.observableArray([]);
        self.hospitals.subscribe(function () {
            self.hospitalsTempNew(JSON.parse(JSON.stringify(self.hospitals())));
        });
        self.hospitalOptions.subscribe(function () {
            self.hospitalsTempOptions(self.hospitalOptions());
        });
        self.hospitalsTempOptionsFiltered = ko.computed(function () {
            return this.hospitalsTempOptions().filter(function (hospital) {
                if (!self.hospitalFilter() || hospital.name.toLowerCase().indexOf(self.hospitalFilter().toLowerCase()) !== -1) return hospital;
            });
        }, this);
        self.clearHospitals = function () {
            self.hospitalsTempNew([]);
        };
        self.hospitalsTempNewClear = function () {
            self.hospitalsTempNew(JSON.parse(JSON.stringify(self.hospitals())));
            self.hospitalFilter("");
        };
        self.hospitalsMakeTempReal = function (data, event) {
            self.hospitals(JSON.parse(JSON.stringify(self.hospitalsTempNew())));
            self.hospitalFilter("");
        };
        // ************************************************************************

        var focusOnPanelStatusCode = false;
        self.panelStatusCode.subscribe(function (val) {
            focusOnPanelStatusCode = true;
        });

        var firstRendered = false;
        self.renderedHandler = function (elements) {
            if (!firstRendered) {
                firstRendered = !firstRendered; // turn off first render
            }

            console.log("renderHandler");
            console.log(elements);

            if (firstRendered && focusOnPanelStatusCode) {
                setTimeout(function () {
                    $('[name="providerPanelStatusCode"]:checked').focus();
                }, 1000);
            }
        };

        self.zipOrAddress.subscribe(function (value) {
            if (!value) {
                self.radiusOptions(utility.mapFacets(window.scan.emptyRadiusOptions));
                self.isSearchStarted(false);
            }
        });

        // this is a computed that will change whenever the user actually changes any of the filters that appear on the page.
        self.filters = ko.computed({
            read: function () {
                focusedElement = document.activeElement;

                if (!self.year()) {
                    self.isSearchStarted(false);
                    utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
                }

                return {
                    year: self.year(),
                    pcponly: self.pcponly(),
                    inofficevisits: self.inofficevisits(),
                    mobileavailable: self.mobileavailable(),
                    mobileonly: self.mobileonly(),
                    telehealthavailable: self.telehealthavailable(),
                    telehealthonly: self.telehealthonly(),
                    lgbtqplus: self.lgbtqplus(),
                    culturetraining: self.culturetraining(),
                    state: self.state(),
                    zipOrAddress: self.zipOrAddress(),
                    name: self.name(),
                    radius: self.radius(),
                    gender: self.gender(),
                    specialties: self.specialties(),
                    panelStatusCode: self.panelStatusCode(),
                    groups: self.groups(),
                    languages: self.languages(),
                    title: self.title(),
                    hospitals: self.hospitals(),
                    //plans: self.plans(),
                    productType: self.plans(),
                    sort: self.sort(),
                    selectPcp: self.selectPcp(),
                    groupId: self.groupId(),
                    deepLink: self.deepLink(),
                    phoneNumber: self.phoneNumber()
                };
            },
            deferEvaluation: true
        });

        self.filters.subscribe(function (result) {
            if (isSystemResettingFilters) {
                return false;
            }
            // console.log('FILTER CHANGE');
            // console.log('==================================== New Value');
            // console.log(result);

            self.detailId(null);
            self.pageNumber(1);
            self.results([]);
            self.totalResults(0);
            self.dataLastUpdated("");
            self.displayRequiredFieldError(false);
            self.fatalError(false);
            self.currentSearchParameters(null);
            tempResults = [];
        });

        self.selectedSpecialtyOptions = ko.computed(function () {
            return self.specialtyOptions().filter(function (item) {
                return self.specialties.indexOf(item.name) !== -1;
            });
        });
        self.unselectedSpecialtyOptions = ko.computed(function () {
            return self.specialtyOptions().filter(function (item) {
                return self.specialties.indexOf(item.name) === -1;
            });
        });

        self.isAnyRequiredFieldPopulated = function () {

            return (self.zipOrAddress() && self.zipOrAddress().length >= 5) || (self.name() && self.name().length >= 3) || self.deepLink() || self.groups().length > 0 || self.phoneNumber().length > 0;
            // return utility.filtersHaveNonDefaultValues(primaryFilters, defaultParameters);
        };

        self.urlParameters = ko.computed(function () {
            var filters = self.filters();

            return {
                year: filters.year,
                pcponly: filters.pcponly,
                inofficevisits: filters.inofficevisits,
                mobileavailable: filters.mobileavailable,
                mobileonly: filters.mobileonly,
                telehealthavailable: filters.telehealthavailable,
                telehealthonly: filters.telehealthonly,
                lgbtqplus: filters.lgbtqplus,
                culturetraining: filters.culturetraining,
                phoneNumber: filters.phoneNumber,
                state: filters.state,
                zipOrAddress: filters.zipOrAddress,
                name: filters.name,
                radius: filters.radius,
                goewPbp: urlParams.goewPbp,
                gender: filters.gender,
                specialties: filters.specialties,
                panelStatusCode: filters.panelStatusCode,
                groups: filters.groups,
                languages: filters.languages,
                title: filters.title,
                hospitals: filters.hospitals,
                //plans: filters.plans,
                productType: filters.productType,
                sort: filters.sort,
                pageNumber: self.pageNumber(),
                detailId: self.detailId(),
                // pass through URL params
                Return_URL: returnUrl,
                findmypcp: findMyPcp,
                Include_Address_Suffix: includeAddressSuffix,
                id: agaId,
                path: path,
                selectPcp: urlParams.selectPcp,
                effectiveDate: self.effectiveDate(),
                groupId: self.groupId(),
                zipOrAddress: self.zipOrAddress(),
                deepLink: self.deepLink(),
                //productType: self.productType()
            };
        });
        self.urlParameters.subscribe(function (params) {
            urlParameters.write(params, defaultParameters);
        });

        // this combines the currently selected values into a parameters object
        // for passing to our facets/results services.
        self.searchParameters = ko.computed(function () {
            var filters = self.filters();

            if (!initialLoad) {
                self.detailId("");
            }

            return {
                year: filters.year,
                pcponly: filters.pcponly,
                inofficevisits: filters.inofficevisits,
                mobileavailable: filters.mobileavailable,
                mobileonly: filters.mobileonly,
                telehealthavailable: filters.telehealthavailable,
                telehealthonly: filters.telehealthonly,
                lgbtqplus: filters.lgbtqplus,
                culturetraining: filters.culturetraining,
                phoneNumber: filters.phoneNumber,
                state: filters.state,
                zipOrAddress: filters.zipOrAddress,
                name: filters.name,
                radius: filters.radius,
                gender: filters.gender,
                sort: filters.zipOrAddress ? filters.sort : "name",
                specialties: filters.specialties,
                panelStatusCode: filters.panelStatusCode,
                groups: filters.groups,
                language: filters.languages,
                title: filters.title,
                hospital: filters.hospitals,
                //plans: filters.plans,
                productType: filters.productType,
                pageNumber: self.pageNumber(),
                pageSize: self.pageSize(),
                selectPcp: self.selectPcp(),
                groupId: self.groupId(),
                effectiveDate: self.effectiveDate(),
                deepLink: self.deepLink(),
                //productType: self.productType()
            };
        });

        self.searchParametersTypeahead = ko.computed(function () {
            var filters = self.filters();

            if (!initialLoad) {
                self.detailId("");
            }

            return {
                year: filters.year,
                pcponly: filters.pcponly,
                inofficevisits: filters.inofficevisits,
                mobileavailable: filters.mobileavailable,
                mobileonly: filters.mobileonly,
                telehealthavailable: filters.telehealthavailable,
                telehealthonly: filters.telehealthonly,
                lgbtqplus: filters.lgbtqplus,
                culturetraining: filters.culturetraining,
                phoneNumber: filters.phoneNumber,
                state: filters.state,
                zipOrAddress: filters.zipOrAddress,
                name: filters.name,
                radius: filters.radius,
                gender: filters.gender,
                // sorting should always be by name in typeahead
                sort: "name",
                specialties: filters.specialties,
                panelStatusCode: filters.panelStatusCode,
                groups: filters.groups,
                language: filters.languages,
                title: filters.title,
                hospital: filters.hospitals,
                //plans: filters.plans,
                productTypes: filters.productType,
                pageNumber: self.pageNumber(),
                pageSize: self.pageSize()
            };
        });

        isSystemResettingFilters = true;
        utility.initializeFilters(self, urlParams, defaultParameters);
        if (returnUrl) {
            self.pcponly(true);
        }
        isSystemResettingFilters = false;

        nonPrimaryFiltersApplied = utility.nonPrimaryFiltersApplied(urlParams, secondaryFilters);

        // loading status

        self.showAllFilters = ko.observable(!self.selectPcp() && nonPrimaryFiltersApplied && !self.deepLink());
        self.toggleShowAllFilters = function () {
            self.showAllFilters(!self.showAllFilters());
        };

        self.hasMore = ko.computed(function () {
            if (!self.totalResults()) {
                return false;
            }
            if (self.pageSize() * self.pageNumber() >= self.totalResults()) {
                return false;
            }
            return true;
        });

        // ************************************************************************

        // this id will be used to keep track of the latest search that we performed.
        // we will throw out any search results that were not for the latest ID.
        // this helps address the scenario where the user is rapidly changing filters
        // and triggering multiple searches.
        // we only want to display results for the last set of search parameters.
        var lastSearchRequestId = 1;

        var executeSearch = function () {
            if (!self.isAnyRequiredFieldPopulated()) {
                self.isSearchStarted(false);
                return;
            }
            // set isSearchStarted to show spinner
            self.isSearchStarted(true);

            // we do not want to collapse the filters if the search is triggered on initial load
            // this causes the scroll position to be incorrectly determined
            // var wasStartedByInitialLoad = initialLoad;

            var id = ++lastSearchRequestId;

            self.loadingResults(true);
            self.fatalError(false);

            var parameters = self.searchParameters();

            self.providerService
                .getResults(parameters) // include results as well as facets
                .done(function (results) {
                    try {
                        if (results == null) {
                            self.results([]);
                            self.isSearchStarted(false);
                            return;
                        }

                        gtmDataLayerPush(parameters, defaultParameters, results.TotalResults);

                        if (id !== lastSearchRequestId) {
                            // ignore any search results that come back for previous searches
                            return;
                        }

                        self.results([]); // clear out results from previous page
                        tempResults = tempResults.concat(results.CurrentResults);
                        for (var i in results.CurrentResults) {
                            if (results.CurrentResults.hasOwnProperty(i)) {
                                self.results.push(new PhysicianResultViewModel(self, results.CurrentResults[i], results.latitude, results.longitude, self.isDrx()));
                            }
                        }
                        if (results.Facets["GENDER"]) {
                            self.genderOptions(
                                results.Facets.GENDER.sort(utility.sortDescendingByCount).concat([
                                    {
                                        count: 0,
                                        name: "",
                                        text: "No Preference",
                                        value: ""
                                    }
                                ])
                            );
                        }

                        if (results.Facets["SPECIALTY"]) {
                            self.specialtyOptions(results.Facets["SPECIALTY"].sort(utility.sortByText));
                        }
                        if (results.Facets["GROUP"]) {
                            self.groupOptions(results.Facets["GROUP"].sort(utility.sortByText));
                        }
                        if (results.Facets["PANELSTATUS"]) {
                            self.panelStatusCodeOptions(
                                results.Facets["PANELSTATUS"].sort(utility.sortByText).concat([
                                    {
                                        count: 0,
                                        name: "",
                                        text: "No Preference",
                                        value: ""
                                    }
                                ])
                            );
                        }
                        if (results.Facets["LANGUAGE"]) {
                            self.languageOptions(results.Facets["LANGUAGE"].sort(utility.sortByText));
                        }
                        if (results.Facets["DEGREE"]) {
                            self.titleOptions(
                                results.Facets["DEGREE"].sort(utility.sortByText).concat([
                                    {
                                        count: 0,
                                        name: "",
                                        text: "No Preference",
                                        value: ""
                                    }
                                ])
                            );
                        }

                        var goewPbp = loadedQuerystring["goewPbp"];
                        if (goewPbp != undefined) {
                            if (goewPbp === true) {
                                self.goewPbp(true);
                            }
                        }
                        if (results.Facets["PRODUCT"]) {
                            self.productOptions(results.Facets["PRODUCT"].sort(utility.sortByText));
                        }
                        if (results.Facets["FACILITY"]) {
                            self.hospitalOptions(results.Facets["FACILITY"].sort(utility.sortByText));
                        }

                        parameters.latitude = results.latitude;
                        parameters.longitude = results.longitude;
                        self.currentSearchParameters(parameters);

                        self.totalResults(results.TotalResults);
                        self.dataLastUpdated(results.LastUpdate);
                        self.loadingResults(false);

                        self.isSearchStarted(false);

                        utility.recalculatePageNumbers(self);
                        self.hasSearchRun(true);

                        if ($(focusedElement).attr("name")) {
                            setTimeout(function () {
                                $("#" + $(focusedElement).attr("id")).focus();
                            }, 100);
                        }
                    } catch (e) {
                        log(e.message);
                        self.isSearchStarted(false);
                    }
                })
                .fail(function () {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }

                    self.fatalError(true);
                    self.loadingResults(false);
                });
        };

        // self.searchParameters.subscribe(function(data) {
        //     console.log('SEARCH PARAMETERS CHANGE');
        //     console.log('==================================== Previous Value');
        //     console.log(data);
        // }, this, "beforeChange");

        self.searchParameters.subscribe(function (newValue) {
            if (isSystemResettingFilters) {
                return false;
            }
            // console.log('SEARCH PARAMETERS CHANGE');
            // console.log('==================================== New Value');
            // console.log(newValue);
            executeSearch();
        });

        // status indicators
        self.pages = ko.computed(function () {
            return Math.ceil(self.totalResults() / self.pageSize());
        });

        self.isAEP = ko.computed(function () {
            return self.yearOptions() && self.yearOptions().length > 1;
        });

        self.arePrimaryFiltersEnabled = ko.computed(function () {
            return !self.isAEP() || self.year();
        });

        var clearFacetOptions = function () {
            self.genderOptions([]);
            self.specialtyOptions([]);
            self.panelStatusCodeOptions([]);
            self.groupOptions([]);
            self.languageOptions([]);
            self.titleOptions([]);
            self.hospitalOptions([]);
            self.productOptions([]);
        };

        var clearFacetOptionsDeepLink = function () {
            if (!urlParams.gender) {
                self.gender("");
            }

            if (!urlParams.specialties) {
                self.specialties([]);
            }

            if (urlParams.panelStatusCode) {
                self.panelStatusCode(urlParams.panelStatusCode);
            }

            if (!urlParams.panelStatusCode) {
                self.panelStatusCode(self.isDrx() ? "ACCEPTS" : "");
            }

            if (!urlParams.groups) {
                self.groups([]);
            }

            if (!urlParams.languages) {
                self.languages([]);
            }

            if (!urlParams.hospitals) {
                self.hospitals([]);
            }

            if (!urlParams.inofficevisits) {
                self.inofficevisits(false);
            }

            if (!urlParams.mobileavailable) {
                self.mobileavailable(false);
            }

            if (!urlParams.mobileonly) {
                self.mobileonly(false);
            }

            if (!urlParams.telehealthavailable) {
                self.telehealthavailable(false);
            }

            if (!urlParams.telehealthonly) {
                self.telehealthonly(false);
            }

            if (!urlParams.lgbtqplus) {
                self.lgbtqplus(false);
            }

            if (!urlParams.culturetraining) {
                self.culturetraining(false);
            }

            if (!urlParams.title) {
                self.title("");
            }

            self.titleOptions([]);
            if (!urlParams.plans) {
                self.productOptions([]);
            }
            self.hasSearchRun(false);
            self.detailId(null);
            if (self.goewPbp() === true) {
                self.pcponly(true);
            }
        };

        self.resetFilters = function () {
            self.phoneNumberErrorMessage("");
            if (urlParams.deepLink) {
                clearFacetOptionsDeepLink();
            } else {
                isSystemResettingFilters = true;
                self.phoneNumber("");
                self.tempPhoneNumber("");
                self.hasSearchRun(false);
                self.detailId(null);
                tempResults = [];
                self.results([]);
                self.totalResults(0);
                self.dataLastUpdated("");
                clearFacetOptions();
                utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
                utility.resetFiltersToDefaults(secondaryFilters, defaultParameters);
                // if in guided online enrollment mode, do not allow the Show PCP Only filter to be reset to unchecked.
                if (self.goewPbp() === true) {
                    self.pcponly(true);
                }
                if (urlParams.productType != undefined) {
                    urlParams.productType = [];
                    self.plans(urlParams.productType);
                }

                if (urlParams.selectPcp != undefined) {
                    self.selectPcp(urlParams.selectPcp);
                }
                isSystemResettingFilters = false;
            }
        };

        self.beginSearch = function (model, event) {
            self.fatalError(false);

            if (self.isAnyRequiredFieldPopulated()) {
                // self.pageNumber(1);
                // self.results([]);
                // self.totalResults(0);
                tempResults = [];
                self.currentSearchParameters(null);
                executeSearch();
            } else {
                self.displayRequiredFieldError(true);
                self.isSearchStarted(false);
            }
        };

        self.setFocusOnResults = function () {
            utility.setFocusOnResults();
        };
        self.loadPrev = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) - 1);
            utility.setFocusOnResults();
        };
        self.loadNext = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) + 1);
            utility.setFocusOnResults();
        };
        self.setPage = function (pageObject) {
            utility.setPageNumber(self, pageObject);
        };
        self.setLastPage = function () {
            self.pageNumber(parseInt(self.pages(), 10));
            utility.setFocusOnResults();
        };

        self.viewDetails = function (providerId, practitionerId, lat, lng) {
            self.isLeavingForDetailPage(true);
            self.detailId(providerId);

            var query = {
                providerId: providerId,
                practitionerId: practitionerId,
                // these are the lat/lng for the queried zipOrAddress, not a particular result
                latitude: lat,
                longitude: lng,
                radius: self.radius(),
                gender: self.gender(),
                specialties: self.specialties(),
                panelStatusCode: self.panelStatusCode(),
                groups: self.groups(),
                languages: self.languages(),
                title: self.title(),
                hospital: self.hospitals(),
                plans: self.plans(),
                year: self.year(),
                state: self.state(),
                pcponly: self.pcponly(),
                inofficevisits: self.inofficevisits(),
                mobileavailable: self.mobileavailable(),
                mobileonly: self.mobileonly(),
                telehealthavailable: self.telehealthavailable(),
                telehealthonly: self.telehealthonly(),
                lgbtqplus: self.lgbtqplus(),
                culturetraining: self.culturetraining(),
                //phoneNumber: self.phoneNumber(),
                sort: self.sort(),
                // pass through URL params
                Return_URL: returnUrl ? returnUrl : "",
                findmypcp: findMyPcp ? findMyPcp : "",
                Include_Address_Suffix: includeAddressSuffix ? includeAddressSuffix : "",
                id: agaId,
                path: path,
                selectPcp: self.selectPcp(),
                effectiveDate: self.effectiveDate(),
                groupId: self.groupId(),
                zipOrAddress: self.zipOrAddress(),
                deepLink: self.deepLink()
            };

            if (!self.selectPcp() || !self.deepLink()) {
                query = urlParameters.reduceParams(query, {});
            }

            window.location.href = window.scan.toolDetailUrl + "?" + querystring.stringify(query);
        };

        self.pdfUrl = ko.computed(function () {
            var params = self.currentSearchParameters();

            if (!params) {
                return null;
            }

            var filteredParams = urlParameters.reduceParams(params, defaultParameters, false);

            if (self.isAEP()) {
                filteredParams.year = self.year();
            }

            filteredParams.contextItemId = self.contextItemId();
            // we need radius sent over every time to make sure the pdf results match on-screen
            filteredParams.radius = params.radius;
            // and the sort
            filteredParams.sort = params.sort;
            filteredParams.pageNumber = self.pageNumber();

            return "/controller/PractitionerSearchPdf/Download?" + querystring.stringify(filteredParams);
        });

        self.emailUrl = ko.computed(function () {
            var urlParts = window.location.href.split("/");

            var domain = urlParts[0] + "//" + urlParts[2],
                downloadLink = domain + self.pdfUrl(),
                subject = encodeURIComponent("Your SCAN Search"),
                body = encodeURIComponent("Download your PDF here: " + downloadLink);

            return "mailto:?subject=" + subject + "&body=" + body;
        });

        function geoLocateZipcode() {
            // use current location to get results
            try {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var latitude = position.coords.latitude;
                            var longitude = position.coords.longitude;

                            // chrome dev tools allows you to set geo sensor to 33.8071979, -118.1444659 (SCAN HQ)
                            geocoder.geodecode(latitude, longitude).then(function (result) {
                                self.zipOrAddress(result.zipcode); // this kicks off a filter update
                            });
                        },
                        function () {
                            console.log("user declined geolocation");
                        }
                    );
                }
            } catch (e) {
                log(e.message);
            }
        }

        self.definitionsRendered = function (el) {
            var $el = $(el).children(".definition");

            if ($toggleDefinitions.hasClass("active")) {
                $el.show().attr("aria-hidden", false);
            } else {
                $el.hide().attr("aria-hidden", true);
            }
        };

        self.triggerGeolocation = function () {
            geoLocateZipcode();
        };

        var maxPage = self.pageNumber();
        var initialPageSize = pageSize;

        if (maxPage > 1) {
            self.pageSize(maxPage * initialPageSize);
        }

        self.beginSearch();
        self.pageSize(initialPageSize);
        self.pageNumber(maxPage);

        initialLoad = false;

        // Google Maps API
        gmapApi.load().then(() => {
            // Google API Autocomplete for addresses
            var defaultBounds = new google.maps.LatLngBounds(new google.maps.LatLng(36.77825900000001, -124.6474231875), new google.maps.LatLng(36.77825900000001, -114.1884388125));

            var options = {
                bounds: defaultBounds
            };

            var input = $(".google-address-lookup").get(0); //document.getElementById("lookup-address");
            var autocomplete;

            autocomplete = new google.maps.places.Autocomplete(input, options);

            google.maps.event.addListener(autocomplete, "place_changed", function () {
                // console.log("auto complete address selected");
                var place = this.getPlace();
                self.zipOrAddress(place.formatted_address);
            });
        });
    };
});
